module.exports = __webpack_public_path__ + "img/file.57de1a2a.svg";